import React, { useContext, useEffect, useState } from 'react';
import ProductCard from './ProductCard';
import { MainContext } from '../context/MainContext';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { categoryIcons } from '../utils/categoryIcons';

const categorySubtitles = {
  orthodontic_pliers: 'Precision instruments for orthodontic procedures',
  brackets: 'Reliable brackets for accurate, efficient treatment',
  bands_and_tubes: 'Durable bands and tubes built to last',
  wires_and_springs: 'High-quality wires and springs for consistent results',
  elastomerics: 'Trusted elastomerics for everyday orthodontic use',
  miscellaneous: 'Essential supplies for your orthodontic practice',
};

const ProductsSection = ({ category }) => {
  const { products } = useContext(MainContext);
  const [cat, setCat] = useState(category);
  const Icon = categoryIcons[category];

  useEffect(() => {
    let formattedStr = category.replace(/_/g, ' ');
    formattedStr = formattedStr.replace(/ and /gi, ' & ');
    setCat(formattedStr);
  }, [category]);

  return (
    <div className="w-full px-4 sm:px-1">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 sm:p-5">
        {/* Compact category header */}
        <div className="flex items-center justify-between gap-3 mb-4">
          <div className="flex items-center gap-3 min-w-0">
            {Icon && (
              <div className="flex-shrink-0 w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-[#EDF1FC] flex items-center justify-center text-[#2D3092]">
                <Icon size={19} strokeWidth={1.75} />
              </div>
            )}
            <div className="min-w-0">
              <h2 className="text-base sm:text-lg md:text-xl font-bold text-[#1B1F4B] capitalize truncate">
                {cat}
              </h2>
              {categorySubtitles[category] && (
                <p className="text-xs sm:text-sm text-gray-500 truncate">{categorySubtitles[category]}</p>
              )}
            </div>
          </div>

          <Link
            to={`/category/${category}`}
            className="flex-shrink-0 inline-flex items-center gap-1 text-xs sm:text-sm font-semibold text-[#2D3092] hover:text-indigo-700 no-underline bg-[#EDF1FC] hover:bg-indigo-100 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full transition-colors"
          >
            View All <ChevronRight size={14} />
          </Link>
        </div>

        {/* Product grid */}
        <div className="grid grid-cols-2 gap-3 sm:flex sm:flex-wrap sm:justify-center sm:gap-0">
          {products
            .filter((item) => item.category === category)
            .slice(0, 5)
            .map((item) => (
              <ProductCard key={item._id} data={item} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsSection;
